import { submitForm } from 'chairisher/util/fetch';
import { logError, setAmplitudeTestTag } from 'chairisher/util/analytics';

/**
 * Binds the $cartForm such that the cart drawer opens when form is submitted.
 * Note: keeping this in its own file allows clients to import this without bringing in all the checkout dependencies.
 * This benefits bundle size. These dependencies are lazy loaded with webpack when the button is clicked.
 *
 * @param {jQuery} $cartForm The form for the "add to cart" cta
 * @param {Object} product The product to which "add to cart" cta is associated
 * @param {Function=} onShow Optional function to call when drawer opens
 */
export default function bindAddToCart($cartForm, product, onShow) {
    const $submitButton = $cartForm.find('button[type="submit"]');

    $cartForm.on('submit', async (e) => {
        e.preventDefault();
        $submitButton.prop('disabled', true);

        try {
            const { default: cartDrawer } = await import('chairisher/component/cart');
            const { data, html } = await submitForm($cartForm.get(0));

            // TODO: (CHAIR-17993) - remove after ab test
            if (data.amplitude_test_tag) {
                setAmplitudeTestTag(data.amplitude_test_tag);
            }

            cartDrawer.initialize(data, html).done(async () => {
                cartDrawer.show();

                if (onShow) {
                    onShow();
                }

                $submitButton.prop('disabled', false);
            });
        } catch (error) {
            logError('cart form submit', error);
        }
    });
}
